import React, {
  Fragment,
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef
} from 'react'
import styles from './styles'
import {
  Box,
  IconButton,
  Button,
  Typography,
  SvgIcon,
  CircularProgress
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PlayCircleIcon from '@material-ui/icons/PlayCircleOutline'
import TextClamp from 'react-string-clamp'
import CalendarIcon from '@material-ui/icons/DateRange'
import moment from 'moment'
import PinIcon from '@material-ui/icons/Room'
import classnames from 'clsx'
import { useFullScreen } from 'react-browser-hooks'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'
import { openLoginDialog } from 'actions/login-dialog'
import { reflow } from 'actions/window'
import { openSnackBar } from 'actions/snack-bar'
import { getUserTickets } from 'actions/event'
import { createTicket } from 'actions/tickets'
import { redeemTickets } from 'actions/tickets'
import { redeemTicket } from 'actions/tickets'
import API from 'store/api'
import { getEventDonations } from 'actions/event'
import { LensTwoTone } from '@material-ui/icons'
import { find } from 'lodash'
import Deferred from 'node-deferred'
import { setVideoDisplay } from 'actions/stream'
import { openRemoteDialog } from 'actions/login-dialog'
import { showSetVideoDisplay } from 'actions/stream'
let checkingTicketsInterval = null

const VideoControls = ({
  event,
  hasLiveVideo,
  videoControlled,
  onPlayButtonClick,
  classes
}) => {
  const tempEventTime = event.start_time
  const windowFullscreen = useSelector(state => state.window.fullscreen)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const myTickets = useSelector(state => state.event.myTickets)
  const myTicketsLoading = useSelector(state => state.event.myTicketsLoading)
  const dispatch = useDispatch()
  const { fullScreen } = useFullScreen()

  const eventState = useSelector(state => state.event)
  const auctionCode = useSelector(state => state.event.event.auction_code)
  const popoutMode = useSelector(state => state.window.popoutMode)
  const inputWaiting = useSelector(state => state.loginDialog.remoteControl)

  const [checkingLiveAccess, setCheckingLiveAccess] = useState(false)
  const shouldShowEventDate = useMemo(() => {
    return (
      event.show_date ||
      event.show_start_time ||
      event.show_end_date ||
      event.show_end_time
    )
  }, [
    event.show_date,
    event.show_start_time,
    event.show_end_date,
    event.show_end_time
  ])

  // state objects to update on an interval
  const [startDateState, setStartDateState] = useState('')
  const [startTimeState, setStartTimeState] = useState('')
  const [remoteInputCheck, setRemoteInputCheck] = useState(0)
  const [startRemote, setStartRemote] = useState(false)
  const [now, setNow] = useState('')

  let dateTimeInterval = useRef(null)

  const clearDateTimeInterval = () => {
    clearInterval(dateTimeInterval.current)
    dateTimeInterval.current = null
  }

  const controlVideo = async (loginRes, showControls = false) => {
    console.log('controlVideo called:', { loginRes, showControls })
    
    const isRehearsal = window.location.pathname.includes('&rehearsal=1') || window.location.pathname.includes('&videomute=1')
    
    if (!find(eventState.event.event_tracking, { id: 'skipLogin' })) {
      if (isEmpty(authenticatedUser) && !loginRes) {
        dispatch(openLoginDialog()).then(async result => {
          const dispatchData = { result: result, event: event }
          setTimeout(async function() {
            const userDispatchRes = await dispatch(
              getUserTickets(result.user_id, eventState.event.auction_code)
            ).then(userTicketsRes => {
              return userTicketsRes
            })
            dispatchData.userDispatchRes = userDispatchRes
            if (userDispatchRes.length === 0) {
              //by deafult create a ticket if they login/regsiter through the modal
              //it doesn't matter if it creates another ticket because it will fail if  there is an already existing ticket
              const purchaseTicketData = await dispatch(
                createTicket(dispatchData)
              ).then(async response => {
                //turn off spinner
                setCheckingLiveAccess(false)
                return response
              })
              //setting it the object to be able to reuse old code
              dispatchData.purchaseTicketData = purchaseTicketData
              //redeem the newly created ticket
              dispatch(redeemTicket(dispatchData))
            } else {
              dispatch(redeemTickets(dispatchData))
            }
          }, 5000)
        })
      } else {
        setTimeout(async function() {
          let dispatchData = {}
          if (loginRes) {
            dispatchData = { result: loginRes, event: event }
          } else {
            dispatchData = { result: authenticatedUser, event: event }
          }
          //get tickets to find the length
          const userDispatchRes = await dispatch(
            getUserTickets(
              dispatchData.result.user_id,
              eventState.event.auction_code
            )
          ).then(userTicketsRes => {
            return userTicketsRes
          })
          //conditional create ticket
          if (userDispatchRes.length === 0) {
            const purchaseTicketData = await dispatch(
              createTicket(dispatchData)
            ).then(async response => {
              return response
            })
            dispatchData.purchaseTicketData = purchaseTicketData
            dispatch(redeemTicket(dispatchData))
          } else {
            //loop through and redeem them
            //console.log(userDispatchRes)
            dispatchData.userDispatchRes = userDispatchRes
            dispatch(redeemTickets(dispatchData))
          }
        }, 5000)
      }
    }
    if (showControls) {
      console.log('showControls is true, keeping video display on')
    } else {
      console.log('Initial setup - will toggle video display')
      // First set to false for initial setup
      dispatch(setVideoDisplay(false))
      
      console.log('Input waiting status:', inputWaiting)
      setStartRemote(true)
      setRemoteInputCheck(2)
      showSetVideoDisplay(false)
      
      // Important: Schedule turning the video display back on immediately after setup
      setTimeout(() => {
        console.log('Toggling video display to true')
        dispatch(setVideoDisplay(true))
      }, 50) 
    }
    
    // Initialize video elements
    console.log('Setting up video elements')
    const videos = [
      document.getElementById('cloudinaryVideo'),
      document.getElementById('egliveVideo')
    ]
    
    console.log('Video elements found:', videos.map(v => v && v.id))
    
    // https://stackoverflow.com/questions/3258587/how-to-properly-unload-destroy-a-video-element
    videos.forEach(video => {
      if (!video) {
        console.log('Video element not found, skipping')
        return
      }
      
      console.log(`Setting up video: ${video.id}`)
      // Only mute videos in rehearsal mode
      video.muted = isRehearsal
      
      /* 
       * Important: We need to enable video playback without cleaning up automatically
       * The cleanup was trying to solve an AbortError but was causing the video not to play
       * We'll remove the cleanup code now since the video needs to continue playing
       */
      setTimeout(() => {
        console.log(`Playing video: ${video.id}`)
        video.play()
          .then(() => {
            console.log(`Play successful for ${video.id}`)
            // Do NOT clean up or pause - we want the video to continue playing
          })
          .catch(err => console.error(`Error playing ${video.id}:`, err))
      }, 100)
    })
    console.log('Setting videoControlled state to true')
    dispatch(
      reflow({
        type: 'videoControlled',
        value: true
      })
    )
    console.log('controlVideo function completed')
  }

  const hasLiveAccessTicket = () => {
    if (event.ticket_count > 0) {
      const liveAccessTicket = event.tags.ticket_types.find(t => t.live_access)
      if (liveAccessTicket) {
        return true
      }
    }
    return false
  }

  //checks for a ticket -> shows controls only
  const userOwnsTicket = (myTicketsResponse, loginRes) => {
    try {
      console.log(myTicketsResponse || myTickets)
      const ownsTicket = (myTicketsResponse || myTickets).length > 0
      //console.log(liveAccessTicket)
      if (ownsTicket) {
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    }
  }

  //checks for live access ticket specifically -> shows video
  const userOwnsLiveAccessTicket = (myTicketsResponse, loginRes) => {
    try {
      const liveAccessTicket = (myTicketsResponse || myTickets)
        .filter(t =>
          t.ticket_holders.find(
            h =>
              parseInt(h.holder_user_id, 10) ===
              parseInt((loginRes || authenticatedUser).user_id, 10)
          )
        )
        .find(t => t.live_access)
      //console.log(liveAccessTicket)
      console.log(userOwnsTicket(myTicketsResponse, loginRes))
      if (liveAccessTicket && !userOwnsTicket(myTicketsResponse, loginRes)) {
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    }
  }

  const checkAccess = userData => {
    //if we check in through the pin method the userData is different compared to regular login userData
    //so we check to see if it has the user property on the userData passed in
    if (userData.hasOwnProperty('user')) {
      //if it does we manual set the user_id property on the userData object where it would be when compared to regular login userData
      userData.user_id = userData.user[0].user_id
    }
    dispatch(getUserTickets(userData.user_id, event.auction_code)).then(
      userTicketsRes => {
        userOwnsTicket(userTicketsRes, userData)
        if (userOwnsLiveAccessTicket(userTicketsRes, userData)) {
          controlVideo(userData)
        } else if (userOwnsTicket(userTicketsRes, userData)) {
          controlVideo(userData, false)
        } else {
          setCheckingLiveAccess(false)
          window.top.postMessage(
            {
              liveApp: {
                action: 'needsLiveAccess'
              }
            },
            '*'
          )
          console.log('user does not own live access ticket 1')
        }
      }
    )
  }

  useEffect(() => {
    if (!inputWaiting && remoteInputCheck > 0) {
      setStartRemote(false)
      if (isEmpty(authenticatedUser)) {
        dispatch(openLoginDialog()).then(loginRes => {
          checkAccess(loginRes)
        })
      } else {
        checkAccess(authenticatedUser)
      }
    }
  }, [inputWaiting, remoteInputCheck])

  useEffect(() => {
    // sets state values for date and time when they are updated
    setStartDateState(event.event_date)
    setStartTimeState(event.startTimeLocal)
  }, [event.event_date, event.startTimeLocal])

  // returns true if current time is winth 15 minutes or -15 minutes of start time
  const checkDateTime = useCallback(() => {
    const m = moment(
      `${startDateState} ${startTimeState}`,
      'YYYY-MM-DD HH:mm:ss'
    )
    const now = moment()
    // gets diff in minutes
    const diff = now.diff(m, 'minutes', true)
    // uses Math.abs to convert negative to passitive for condition check
    return Math.abs(diff) <= 15
  }, [startDateState, startTimeState])

  const shouldShowStartingSoon = useMemo(() => {
    if (event.show_start_time && !event.live_settings.is_live) {
      if (startDateState && startTimeState) {
        const dateTimeDiffValue = checkDateTime()
        // if dateTimeDiffValue = false, clearInterval
        clearDateTimeInterval()
        return dateTimeDiffValue
      }
    } else {
      if (dateTimeInterval.current !== null) {
        // show_start_time toggled to false, clear interval if it started
        clearDateTimeInterval()
      }
    }
    return false
  }, [
    event.show_start_time,
    startDateState,
    startTimeState,
    dateTimeInterval.current,
    now,
    event.live_settings.is_live
  ])

  useEffect(() => {
    // starts an interval to check the start time
    setStartDateState(event.event_date)
    setStartTimeState(event.startTimeLocal)
    if (
      !event.live_settings.is_live &&
      event.show_start_time &&
      dateTimeInterval.current === null &&
      checkDateTime()
    ) {
      dateTimeInterval.current = setInterval(() => {
        setNow(moment().unix())
      }, 5000)
    }
  }, [
    event.live_settings.is_live,
    event.event_date,
    event.startTimeLocal,
    event.show_start_time,
    startDateState,
    startTimeState,
    dateTimeInterval.current
  ])

  //variables for determining if we should show icon or not
  const shouldShowStartIcon = useMemo(() => {
    return event.show_date && event.event_date !== null
  })

  const shouldShowEndIcon = useMemo(() => {
    return event.show_end_date && event.end_event_date !== null
  })

  //set up the elements to have no display untill play has been hit
  setTimeout(() => {
    if (document.getElementById('fullDetailsButtonOne')) {
      document.getElementById('fullDetailsButtonOne').tabIndex = '-1'
    }
    if (document.getElementById('sendCommentTextOne')) {
      document.getElementById('sendCommentTextOne').tabIndex = '-1'
    }

    if (document.getElementById('emojiSelectorOne')) {
      document.getElementById('emojiSelectorOne').tabIndex = '-1'
    }
    if (document.getElementById('sendMessageOne')) {
      document.getElementById('sendMessageOne').tabIndex = '-1'
    }
  }, 1000)

  const handleClick = () => {
    clearDateTimeInterval()
    dispatch(getEventDonations(event.auction_code))
    setCheckingLiveAccess(true)
    
    const isRehearsal = window.location.pathname.includes('&rehearsal=1') || window.location.pathname.includes('&videomute=1')
    
    // Skip ticket checks in rehearsal mode
    if (isRehearsal) {
      controlVideo()
      return
    }
    
    if (hasLiveAccessTicket()) {
      if (isEmpty(authenticatedUser)) {
        dispatch(openLoginDialog())
          .then(loginRes => {
            checkAccess(loginRes)
            if (document.getElementById('fullDetailsButtonOne')) {
              document.getElementById('fullDetailsButtonOne').tabIndex = '0'
            }
            if (document.getElementById('sendCommentTextOne')) {
              document.getElementById('sendCommentTextOne').tabIndex = '0'
            }
            if (document.getElementById('emojiSelectorOne')) {
              document.getElementById('emojiSelectorOne').tabIndex = '0'
            }
            if (document.getElementById('sendMessageOne')) {
              document.getElementById('sendMessageOne').tabIndex = '0'
            }
          })
          .fail(() => setCheckingLiveAccess(false))
      } else {
        checkAccess(authenticatedUser)
      }
    } else {
      controlVideo()
    }
  }

  const hideIFrame = () => {
    // dispatch(openRemoteDialog()).then(result => {
    //   console.log('hello there')
    //   console.log(result)
    // })

    dispatch(setVideoDisplay(false))
    console.log(inputWaiting)
    setStartRemote(true)
    setRemoteInputCheck(2)
    // setTimeout(function() {
    //   var statusInterval = setInterval(checkStatus, 1000)
    //   function checkStatus() {
    //     console.log(inputWaiting)
    //     if (!inputWaiting) {
    //       console.log('yo')
    //       clearInterval(statusInterval)
    //       if (isEmpty(authenticatedUser)) {
    //         dispatch(openLoginDialog()).then(loginRes => {
    //           checkAccess(loginRes)
    //         })
    //       } else {
    //         checkAccess(authenticatedUser)
    //       }
    //     }
    //   }
    // }, 500)
  }

  return (
    <Box
      className={classnames(classes.videoControls, {
        [classes.isFullscreen]: fullScreen || windowFullscreen,
        [classes.popout]: popoutMode
      })}
    >
      <Box className={classes.eventDetails}>
        {/* <Typography variant="h3" className={classes.liveEventText}>
          Online Live Event
        </Typography> */}
        <Typography variant="h2" className={classes.eventTitle}>
          <TextClamp text={event.auction_title} lines={4} />
        </Typography>
        {shouldShowStartingSoon && (
          <div>
            <Typography variant="h2" className={classes.startingSoonTitle}>
              Starting Soon <span className="loader__dot">.</span>
              <span className="loader__dot">.</span>
              <span className="loader__dot">.</span>
              {/* loading animation is in base.css */}
            </Typography>
          </div>
        )}
        {event.live_settings.is_live && (
          <Box
            className={classnames(classes.liveNowBox, {
              [classes.liveNowBoxHidden]: videoControlled
            })}
          >
            {!checkingLiveAccess && (
              <Fragment>
                <IconButton
                  disableRipple="true"
                  //className={classes.playButtonFocused}
                  aria-label="start watching the event"
                  classes={{
                    root: classes.playButton
                    //focusVisible: classes.playButtonFocused
                  }}
                  onClick={handleClick}
                  //autoFocus
                >
                  <SvgIcon className={classes.playIcon}>
                    <filter id="glow">
                      <feGaussianBlur
                        id="gblur"
                        stdDeviation="1.2"
                        result="coloredBlur"
                      />
                      <feMerge>
                        <feMergeNode in="coloredBlur" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                    <animate
                      xlinkHref="#gblur"
                      id="anim-gblur"
                      attributeName="stdDeviation"
                      values="0;1.2;0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    {/* <filter id="dropshadow" height="130%">
                      <feGaussianBlur in="SourceAlpha" stdDeviation="1.5" />
                      <feColorMatrix
                        id="recolor"
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        result="white-glow"
                      />
                      <feOffset dx="0" dy="0" result="offsetblur" />
                      <feComponentTransfer>
                        <feFuncA type="linear" slope="0.5" />
                      </feComponentTransfer>
                      <feMerge>
                        <feMergeNode in="white-glow" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter> */}
                    <path
                      style={{
                        filter: 'url(#glow)'
                      }}
                      d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                    />
                  </SvgIcon>
                  <Typography variant="h2" className={classes.liveNowText}>
                    Start Event
                  </Typography>
                </IconButton>
                {/* at the event */}
                <IconButton
                  disableRipple="true"
                  //className={classes.playButtonFocused}
                  aria-label="start watching the event"
                  classes={{
                    root: classes.playButton
                    //focusVisible: classes.playButtonFocused
                  }}
                  onClick={hideIFrame}
                  //autoFocus
                >
                  <Typography variant="h2" className={classes.liveNowText}>
                    At The Event
                  </Typography>
                </IconButton>
              </Fragment>
            )}
            {checkingLiveAccess && (
              <Fragment>
                <Box className={classes.liveAccessProgress}>
                  <CircularProgress className={classes.progress} />
                </Box>
                <Typography variant="h2" className={classes.liveNowText}>
                  Checking Live Access
                </Typography>
              </Fragment>
            )}
          </Box>
        )}
        {!event.live_settings.is_live &&
          (window.location.pathname.includes('&rehearsal=1') ||
            window.location.pathname.includes('&videomute=1')) && (
            <Box
              className={classnames(classes.liveNowBox, {
                [classes.liveNowBoxHidden]: videoControlled
              })}
            >
              {!checkingLiveAccess && (
                <Fragment>
                  <IconButton
                    disableRipple="true"
                    //className={classes.playButtonFocused}
                    aria-label="start watching the rehearsal event"
                    classes={{
                      root: classes.playButton
                      //focusVisible: classes.playButtonFocused
                    }}
                    onClick={handleClick}
                    autoFocus
                  >
                    <SvgIcon className={classes.playIcon}>
                      <filter id="glow">
                        <feGaussianBlur
                          id="gblur"
                          stdDeviation="1.2"
                          result="coloredBlur"
                        />
                        <feMerge>
                          <feMergeNode in="coloredBlur" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>
                      <animate
                        xlinkHref="#gblur"
                        id="anim-gblur"
                        attributeName="stdDeviation"
                        values="0;1.2;0"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                      {/* <filter id="dropshadow" height="130%">
                      <feGaussianBlur in="SourceAlpha" stdDeviation="1.5" />
                      <feColorMatrix
                        id="recolor"
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                        result="white-glow"
                      />
                      <feOffset dx="0" dy="0" result="offsetblur" />
                      <feComponentTransfer>
                        <feFuncA type="linear" slope="0.5" />
                      </feComponentTransfer>
                      <feMerge>
                        <feMergeNode in="white-glow" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter> */}
                      <path
                        style={{
                          filter: 'url(#glow)'
                        }}
                        d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                      />
                    </SvgIcon>
                    <Typography variant="h2" className={classes.liveNowText}>
                      Start Event
                    </Typography>
                  </IconButton>
                </Fragment>
              )}
              {checkingLiveAccess && (
                <Fragment>
                  <Box className={classes.liveAccessProgress}>
                    <CircularProgress className={classes.progress} />
                  </Box>
                  <Typography variant="h2" className={classes.liveNowText}>
                    Checking Live Access
                  </Typography>
                </Fragment>
              )}
            </Box>
          )}
        {!event.live_settings.is_live &&
          !window.location.pathname.includes('&rehearsal=1') && (
            <Fragment>
              {/*as long as one of the values from the useMemo is true show the icon */}
              {shouldShowEventDate && (
                <Box className={classes.detailsLine}>
                  {(shouldShowStartIcon || shouldShowEndIcon) && (
                    <CalendarIcon />
                  )}
                  <Typography variant="h3">
                    {event.show_date &&
                      event.event_date !== null &&
                      moment(event.event_date, 'YYYY-MM-DD').format(
                        'ddd, MMM DD'
                      )}
                    {event.show_date && event.show_start_time && ' '}
                    {event.show_start_time &&
                      event.event_date !== null &&
                      moment(event.startTimeLocal, 'HH:mm:ss').format(
                        'hh:mm A'
                      )}
                    {(event.show_end_date || event.show_end_time) && ' - '}
                    {event.show_end_date &&
                      event.end_event_date !== null &&
                      moment(event.end_event_date, 'YYYY-MM-DD').format(
                        'ddd, MMM DD'
                      )}
                    {event.show_end_date && event.show_end_time && ' '}
                    {event.show_end_time &&
                      event.end_event_date !== null &&
                      moment(event.endTimeLocal, 'HH:mm:ss').format('hh:mm A')}
                  </Typography>
                </Box>
              )}
              {event.route && event.show_address && (
                <Box className={classes.detailsLine}>
                  <PinIcon />
                  <Typography variant="h3">
                    {event.place_name && (
                      <span className={classes.address}>
                        {event.place_name}
                        <br />
                        <span className={classes.cityStateZip}>
                          {event.place_formatted_address}
                        </span>
                      </span>
                    )}
                    {!event.place_name && (
                      <span className={classes.address}>
                        {event.street_number} {event.route}
                        <br />
                        <span className={classes.cityStateZip}>
                          {event.city},{event.state} {event.zip}
                        </span>
                      </span>
                    )}
                  </Typography>
                </Box>
              )}
            </Fragment>
          )}
      </Box>
    </Box>
  )
}

export default withStyles(styles)(VideoControls)



// WEBPACK FOOTER //
// ./src/components/LiveVideo/VideoControls/index.jsx